import { queryOptions } from '@tanstack/react-query'

import { HOUR } from '@/core/constants/constants'
import { StartingPage } from '@/core/constants/startingPage'

import { createApiMethod, type } from './utils/createApiMethod'

export type Company = {
  id: string
  background_image_id?: string
  color?: string
  email_domains?: string[]
  enable_stripe_management?: boolean
  extra_data?: Record<string, unknown>
  logo_id?: string
  name: string
  is_user_signup_email_edit_disabled?: boolean
  default_platform_start_page?: StartingPage
  support_person?: SupportPerson
  unlimited?: boolean
}

export type SupportPerson = {
  email?: string
  gender?: string
  name?: string
  phone?: string
  picture_id?: string
}

export const company = {
  details: createApiMethod({
    method: 'GET',
    path: '/company',
    response: type<Company>(),
  }),

  update: createApiMethod({
    method: 'PUT',
    path: '/company',
    data: type<{
      is_user_signup_email_edit_disabled: boolean
      logo_data: string
      default_platform_start_page?: StartingPage
    }>(),
  }),

  noEmailUsers: {
    details: createApiMethod({
      method: 'GET',
      path: '/company/:ssoSourceId/no_email_users',
      response: type<Record<string, never>>(),
    }),
  },
}

export const companyQueries = {
  all: () => ['company'] as const,
  detail: () =>
    queryOptions({
      queryKey: [...companyQueries.all(), 'detail'] as const,
      queryFn: () => company.details(),
      staleTime: HOUR * 12,
    }),
}
